<template>
  <DesktopHeader class="header desktop" />
  <MobileHeader
    class="header mobile"
    :is-sidebar-open="isSidebarOpen"
    @update:set-mobile-search-open="setMobileSearchOpen"
    @update:set-sidebar-open="setSidebarOpen"
  />
  <div class="layout-body">
    <Sidebar
      class="sidebar"
      :class="{show: isSidebarOpen && !isMobileSearchOpen}"
    />
    <div
      class="content-container"
      :class="isMobile && (isSidebarOpen || isMobileSearchOpen) ? 'opacity-0' : 'opacity-100'"
    >
      <slot />
      <Footer class="footer" />
    </div>
  </div>
  <MobileSearch
    v-if="isMobileSearchOpen"
    class="mobile-search"
    @update:set-mobile-search-open="setMobileSearchOpen"
  />
</template>

<script lang="ts" setup>
import { onBeforeRouteUpdate } from '#app'
import Footer from '~/components/footer/Footer.vue'
import DesktopHeader from '~/components/header/desktop/DesktopHeader.vue'
import MobileSearch from '~/components/header/mobile/mobile-search/MobileSearch.vue'
import MobileHeader from '~/components/header/mobile/MobileHeader.vue'
import Sidebar from '~/components/sidebar/Sidebar.vue'
import { useMedia } from '~/composables/useMedia'

const { isDesktop, isMobile } = useMedia()

const isMobileSearchOpen = ref(false)

const setMobileSearchOpen = (value = !isMobileSearchOpen.value) => {
  isMobileSearchOpen.value = value
}

const isSidebarOpen = ref(false)

const setSidebarOpen = (value = !isSidebarOpen.value) => {
  isSidebarOpen.value = value
}

onBeforeRouteUpdate(() => {
  setMobileSearchOpen(false)
  setSidebarOpen(false)
})

watchEffect(() => {
  if (isDesktop.value) {
    setMobileSearchOpen(false)
    setSidebarOpen(false)
  }
})
</script>

<style lang="scss" scoped>
.header {
  @apply fixed top-0;
  z-index: 2000;

  &.desktop {
    @include mobile {
      @apply hidden;
    }
  }

  &.mobile {
    @apply hidden;
    @include mobile {
      @apply flex;
    }
  }
}

.layout-body {
  @apply mt-[4.5rem] flex max-w-full;
  min-height: calc(100vh - 4rem);

  @include mobile {
    @apply mt-14;
  }

  .sidebar {
    @apply fixed top-[4.5rem] border-r border-default/10 shrink-0;

    @include mobile {
      @apply hidden;

      &.show {
        @apply flex w-full top-14 border-0 z-30;
        max-height: calc(100% - 72px);
      }
    }
  }

  .content-container {
    @apply w-full flex flex-col items-center h-full ml-[216px] border-x border-default/10;

    @include mobile {
      @apply ml-0 pb-4 z-10;
    }
  }

  .footer {
    @apply border-t border-default/10;
  }
}

.mobile-search {
  @apply fixed top-0 left-0 w-full hidden;
  z-index: 3000;

  @include mobile {
    @apply block;
  }
}
</style>